import {useVickyAIRecommendations} from '../../../../../hooks/use-vicky-recommendations'

import {dynamicSourceToAIModel} from './helpers'

const PRODUCT_SCOPED_AI_MODELS = new Set(['bought-together', 'shop-the-look', 'similars'])
const REFERENCE_REQUIRED_AI_MODELS = new Set([...PRODUCT_SCOPED_AI_MODELS, 'semantic-search'])

/* Translate the CMS dynamic-content dropdown into a list of GDIProductTileBlock
 * pseudo-tiles, fetching products from VickyAI. SSR may have already resolved
 * `_recommendationData` server-side (see `resolveVickyCarouselData` in ssr.js);
 * if so we use it directly and skip the client hook. The hook is still
 * declared (with 'skip' aiModel) so hook order stays stable. */
export const useVickyTiles = (dynamicContent, ssrData, dynamicReference = null, options = {}) => {
    const {availabilityEnabled = true} = options
    const aiModel = dynamicSourceToAIModel(dynamicContent)
    const hasSSRProducts = Array.isArray(ssrData?.products)
    const requiresReference = REFERENCE_REQUIRED_AI_MODELS.has(aiModel)
    const canFetchClient =
        !hasSSRProducts && !!aiModel && (!requiresReference || !!dynamicReference)
    const {products: clientProducts, isLoading} = useVickyAIRecommendations(
        canFetchClient ? aiModel : 'skip',
        canFetchClient && requiresReference ? dynamicReference : null,
        {availabilityEnabled}
    )
    const products = hasSSRProducts ? ssrData.products : clientProducts
    if (!aiModel || (!hasSSRProducts && !canFetchClient)) return {tiles: [], isLoading: false}
    /* Pass the Vicky-enriched product object directly to each tile so
     * `GDIProductTileBlock` skips its SFCC `useProducts` fetch — Vicky's
     * payload already includes everything ProductTile needs. */
    return {
        tiles: (products || []).map((p) => ({
            __typename: 'GDIProductTileBlock',
            Product: p,
            ContentLink: {GuidValue: `vicky-${p.id}`}
        })),
        isLoading: !hasSSRProducts && isLoading
    }
}
